import { type FC } from 'react'

import error from '@core/assets/v2/icons/status/solid/Icon-Error-Solid.png'
import expectation from '@core/assets/v2/icons/status/solid/Icon-Expectation-Solid.png'
import info from '@core/assets/v2/icons/status/solid/Icon-Info-Solid.png'
import questionCircle from '@core/assets/v2/icons/status/solid/Icon-Question-Circle-Solid.png'
import status from '@core/assets/v2/icons/status/solid/Icon-Status-Solid.png'
import warning from '@core/assets/v2/icons/status/solid/Icon-Warning-Solid.png'
import xCircle from '@core/assets/v2/icons/status/solid/Icon-X-Circle-Solid.png'

import { createIcon } from './createIcon'
import type { IconProps, StatusIconName } from './types'

export const IconError = createIcon(error, 'Error')
export const IconExpectation = createIcon(expectation, 'Expectation')
export const IconInfo = createIcon(info, 'Info')
export const IconQuestionCircle = createIcon(questionCircle, 'QuestionCircle')
export const IconStatus = createIcon(status, 'Status')
export const IconWarning = createIcon(warning, 'Warning')
export const IconXCircle = createIcon(xCircle, 'XCircle')

export const statusIcons: Record<StatusIconName, FC<IconProps>> = {
    Error: IconError,
    Expectation: IconExpectation,
    Info: IconInfo,
    QuestionCircle: IconQuestionCircle,
    Status: IconStatus,
    Warning: IconWarning,
    XCircle: IconXCircle,
}
